export class SavingsAmounts {
    endAmountDaxOneTime?: number;
    endAmountDaxSavingsPlan?: number;
    endAmountSavingsAccount?: number;
    oneTimeSavings?: number;
    sumMonthlySavings?: number;
    sumInpaymentSavingsAccount?: number;
}
